import React from "react";
import { useAuth } from "@/context/AuthContext";
import { printA4, shareWhatsApp } from "@/lib/print";
import { money } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer, FileDown, Share2, History } from "lucide-react";

export function DocActions({ doc, settings, quotation = true, onHistory }) {
  const { hasPerm } = useAuth();
  if (!doc) return null;
  return (
    <div className="grid grid-cols-2 gap-2">
      {hasPerm("print") && <Button variant="outline" onClick={() => printA4(doc, settings?.business, settings?.bill, quotation)} data-testid="doc-print"><Printer className="h-4 w-4 mr-1.5" />Print</Button>}
      {hasPerm("pdf_export") && <Button variant="outline" onClick={() => printA4(doc, settings?.business, settings?.bill, quotation)} title="Choose 'Save as PDF' in the print window" data-testid="doc-pdf"><FileDown className="h-4 w-4 mr-1.5" />PDF</Button>}
      {hasPerm("whatsapp_share") && <Button variant="outline" onClick={() => shareWhatsApp(doc, settings?.business, doc.customer_phone, quotation)} data-testid="doc-share"><Share2 className="h-4 w-4 mr-1.5" />Share</Button>}
      {onHistory && <Button variant="outline" onClick={onHistory} data-testid="doc-history"><History className="h-4 w-4 mr-1.5" />History</Button>}
    </div>
  );
}

export function QuoteSavedDialog({ doc, settings, onClose, onHistory }) {
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-sm" data-testid="quote-saved-dialog">
        <DialogHeader><DialogTitle>Quotation {doc?.q_no} saved</DialogTitle><DialogDescription>Total {money(doc?.grand_total || 0)} · no stock changed</DialogDescription></DialogHeader>
        <DocActions doc={doc} settings={settings} onHistory={onHistory} />
      </DialogContent>
    </Dialog>
  );
}
